import React from "react";

/**
 * Consistent page title / subtitle / actions row.
 * Replaces the ad-hoc <Space justify="space-between"> pattern used per page.
 */
const PageHeader = ({ title, subtitle, actions }) => (
  <div className="i-ems-page-header">
    <div>
      <h1 className="i-ems-page-header-title">{title}</h1>
      {subtitle ? <div className="i-ems-page-header-subtitle">{subtitle}</div> : null}
    </div>
    {actions ? <div className="i-ems-page-header-actions">{actions}</div> : null}
  </div>
);

export default PageHeader;
